<template>
	<div class="check_group_wrapper" v-if="options.length">
		<el-checkbox
			v-waves
			class="checkbox_item"
			:indeterminate="indeterminate"
			v-model="checkAll"
			@change="handleCheckAll"
		>{{$t("common.全选")}}</el-checkbox>
		<el-checkbox
			v-waves
			class="checkbox_item"
			v-for="(item,i) in options"
			:label="item[option.label]"
			:value="checkedValues.includes(item[option.label])"
			:key="i"
			@change="onItemChange(item)"
		>{{item[option.text]}}</el-checkbox>
	</div>
</template>

<script>
	export default {
		name: 'clCheckboxGroup',
		props: {
			options: {
				type: Array,
				default: () => ([])
			},
			option: {
				type: Object,
				default: () => ({
					label: 'id',
					text: 'itemName'
				})
			},
			value: {
				type: Array,
				default: () => ([])
			},
		},

		data() {
			return {
				description: '全选和其他多选是兄弟元素的多选框，可以正常折行，而不是多选独占一行。',
				checkAll: false,
				checkedValues: [],
			}
		},

		watch: {
			value: {
				immediate: true,
				handler() {
					this.checkedValues = [...this.value]
				}
			},
		},

		computed: {
			indeterminate() {
				return this.checkedValues.length > 0 && this.checkedValues.length !== this.options.length
			}
		},

		methods: {
			onItemChange(item) {
				const arr = this.checkedValues
				const index = arr.indexOf(item[this.option.label])
				if (index === -1) {
					arr.push(item[this.option.label])
				} else {
					arr.splice(index, 1)
				}
				if (arr.length === this.options.length) {
					this.checkAll = true
					this.handleCheckAll()
				} else {
					this.checkAll = false
				}
				this.$emit('change', arr)
			},

			handleCheckAll() {
				this.checkedValues = this.checkAll ? this.options.map(item => item[this.option.label]) : [this.options[0][this.option.label]]
				this.$emit('change', this.checkedValues)
			}
		},

		model: {
			prop: 'value',
			event: 'change'
		}
	}
</script>

<style lang="scss" scoped>
	.check_group_wrapper {
		.checkbox_item {
			margin-bottom: 10px;
		}
	}
</style>